<template>
  <div class="app-default-layout">
    <the-header></the-header>
    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
  </div>
</template>

<script>
import TheHeader from '@/components/single/the-header/the-header'
export default {
  data() {
    return {}
  },
  components: {
    TheHeader
  }
}
</script>
